/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCoin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-coin_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-coin_svg__st0"
      d="M14 11h-1V9h3V7h-3V6h-2v1h-1c-1.7 0-3 1.3-3 3s1.3 3 3 3h1v2H8v2h3v1h2v-1h1c1.7 0 3-1.3 3-3s-1.3-3-3-3zm-3 0h-1c-.6 0-1-.4-1-1s.4-1 1-1h1v2zm3 4h-1v-2h1c.6 0 1 .4 1 1s-.4 1-1 1z"
    />
    <path
      className="ico-coin_svg__st0"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
    />
  </Icon>
);
export { SvgCoin as Coin };
